module.exports = {
      id: "ic-btcusd-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-2c53a1.smartcharts.svg#ic-btcusd-usage",
      toString: function () {
        return this.url;
      }
    }